<template>
<div>
  <span v-if="display">{{user_data}}</span>
  <span v-else>
    <input :title="'UserID: ' + user_id" :value='user_data' @input="search($event.target.value)" type='text' placeholder="Search By Users Last Name" :required="required" />
    <div class='search' v-if="show_search_results">
      <div v-if='searching' class='search_icon'><img src="/files/imgs/loading.svg" /></div>
      <div class='user' v-for='user in users' @click="user_id=user.id; user_data=user.name; show_search_results=false; $emit('input', user.id)">{{user.name}}</div>
      <div v-if="users.length===0 && !searching && user_data.length >= 3">No Results</div>
    </div>
    </span>
</div>
</template>

<script>
export default {
    props: {
	value   : { type: Number, String },
	display : { type: Boolean },
	required: { type: Boolean },
	choices : { type: Array   },
	
    },
    data: function() { return {
        searching: false,
        user_id: 0,
        user_data: '',
        users: [],
        show_search_results: false,
    }},
    mounted: function() {
        this.user_id = this.value
        var self = this
        if(this.user_id == 0 || this.user_id == null) {
            return
        }
	if(this.choices) {
	    var u = this.choices.find(u => u[0] == this.user_id)
	    if(u !== undefined) {
		this.user_data = u[1]
		return
	    }
	}
        self.rpc('entity','Users','search_by_id', {id: this.user_id}, "__bg__")
            .then(function(data) {
                console.log(data)
		self.user_data = data.name
            })
            .catch(function(error) {
                self.$store.commit('setError',{show:true, msg:error.result})
            })
    },
    methods: {
        search:function(value) {
            this.user_data = value
            this.user_id = 0
            this.$emit('input', 0)
            var self = this
            if(value.length < 3) {
                return
            }
            self.searching=true;
            self.show_search_results=true;
            self.rpc('entity', 'Users', 'user_search', {value:value}, "__bg__")
                .then(function(data) {
                    self.users = data
                    self.searching = false
                })
                .catch(function(error) {
                    self.$store.commit('setError',{show:true, msg:error.result})
                    self.searching = false
                })
        }
    }
}
</script>

<style scoped>
.search {
    position: absolute;
    display: flex;
    flex-direction: column;
    border: 1px solid #888;
    border-top: 0;
    padding: 10px;
    max-height: 200px;
    overflow: auto;
    max-width: 200px;
    cursor: pointer;
    background-color: white;
}
.search_icon {
    text-align: center;
}
.search_icon img {
    width: 16px;
}
.user {
    white-space: nowrap;
    padding: 2px 0;
}
</style>
